import gsap from 'gsap';
import lodash from 'lodash';
export const Modal = {
  init() {
    const opens = document.querySelectorAll('[data-modal-open]');
    if (opens.length) {
      opens.forEach((open) => {
        open.addEventListener('click', () => {
          const modal = document.getElementById(open.dataset.modalOpen);
          if (lodash.isElement(modal)) {
            document.body.classList.add('is-fixed');
            gsap.to(modal, {
              autoAlpha: 1,
            });
            const closes = modal.querySelectorAll('[data-modal-close]');
            if (closes.length) {
              closes.forEach((close) => {
                close.addEventListener('click', () => {
                  gsap.to(modal, {
                    autoAlpha: 0,
                  });
                  document.body.classList.remove('is-fixed');
                });
              });
            }
          }
        });
      });
    }
  },
};
